var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',_vm._g(_vm._b({attrs:{"src":_vm.src,"alt":_vm.computed_alt}},'v-img',_vm.merged_attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }